import PageHeader from "components/Page/PageHeader";
import RelatorioAuditoriaContent from "../RelatorioAuditoriaContent";
import useFiltroRelatorioAuditoria from "../../hooks/useFiltroRelatorioAuditoria";
import { useRelatorioAuditoriaInfiniteScroll } from "core/features/relatorios/hooks/useRelatorioAuditoriaInfiniteScroll";
import { useMemo } from "react";
import { RelatorioAuditoriaItem } from "core/features/relatorios/typings";
import DateRangePicker from "components/Input/DateRangePicker";

export default function ListaRelatorioAuditoria() {
  const { filtro, onChangeFiltro, onResetFiltro } =
    useFiltroRelatorioAuditoria();

  const {
    data: dataAuditoria,
    isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useRelatorioAuditoriaInfiniteScroll(filtro);

  const data = useMemo(() => {
    return (
      dataAuditoria?.pages.reduce(
        (agg: RelatorioAuditoriaItem[], item) => agg.concat(item.items ?? []),
        []
      ) ?? []
    );
  }, [dataAuditoria]);
  return (
    <>
      <PageHeader
        justifyContent="space-between"
        title="Auditoria"
        midComponent={
          <DateRangePicker
            maxRangeDays={90}
            onChange={(dataInicio, dataFim) => {
              onChangeFiltro({
                dataInicio,
                dataFim,
              });
            }}
            allowEmptyDates={{
              dataFim: false,
              dataInicio: false,
            }}
            value={{
              dataInicio: filtro.dataInicio,
              dataFim: filtro.dataFim,
            }}
          />
        }
      />

      <RelatorioAuditoriaContent
        data={data}
        filtro={filtro}
        isLoading={isLoading}
        onChangeFiltro={onChangeFiltro}
        onResetFiltro={onResetFiltro}
        fetchNextPage={fetchNextPage}
        hasNextPage={!!hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    </>
  );
}
